<template>
        <div class="otp_container-backdrop">
                <div class="otp_container text-center p-4 bg-light">
                        <h4 class="otpheading mb-4">OTP Verification</h4>
                        <p v-if="state.maskedData">OTP has been sent successfully to <span class="link_highlight">{{ state.maskedData.mobileNo }}</span> and <span class="link_highlight">{{ state.maskedData.email }}</span> and will be valid until {{ state.maskedData.expiredAt }}.</p>
                        <div class="otp_numbers mt-4 mb-2  p-3">
                                <div class="otp_inputs d-flex align-items-bottom justify-content-center">
                                        <input 
    :ref="el => (refs[otp.id] = el)" 
    v-for="(otp, index) in state.otpNumbers"
    :key="index" 
    :id="'otp-' + index" 
    v-model="otp.value"
    @input="onInput($event, index)" 
    @keydown="onKeyDown($event, index)"
    @paste="onPaste($event, index)"
    maxlength="1" 
    class="otp-input"
    type="text" 
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="off" 
/>

                                </div>
                        </div>
                        <p class="expiryErrorMessage"
                                :class="{ 'expiryError': state.errorOtpMessage}"
                                v-if="state.errorOtpMessage && hideMessage"
                                >
                                {{ state.errorOtpMessage }}
                        </p> 
                        <p class="expiryErrorMessage"
                                :class="{ 'expirySuccess': state.OtpExpiryMessage?.type === 'success'}"
                                v-if="state.OtpExpiryMessage?.msg && hideMessage">
                                {{ state.OtpExpiryMessage.msg }}
                        </p> 
                        <!-- <p class="expiryErrorMessage"
                                :class="{ 'expirySuccess': state.OtpExpiryErrorMessage?.type === 'success'}"
                                v-if="state.OtpExpiryErrorMessage?.msg"
                                >
                                {{ state.OtpExpiryErrorMessage.msg }}
                        </p>  -->
                        <p v-if="time">Resend OTP in {{ time }} sec</p>
                        <p class="mt-3" v-else>Didn't get the code? <span class="resend"
                                        @click="resendOtp($event)">Resend</span></p>
                        <button @click="validateOTP()" class="btn commonButton mt-4" :disabled="disableVerify">Verify &
                                Submit</button>
                        <button class="btn backbutton " @click="cancleOtpVerify">Cancel</button>
                </div>
                <PageLoader v-if="state.loadingState" :msg="state.loadingMessage"/>
                <!-- Payment In Progress Dialog -->
                <PaymentInProgressDialog 
                        v-model:visible="state.showPaymentInProgressModal"
                        :message="state.paymentInProgressMessage"
                        @handleContinue="handlePaymentInProgressContinue"
                        @handleCancel="handlePaymentInProgressCancel" />
                <!-- END: Payment In Progress Dialog -->
        </div>
</template>
<script setup>
import { ref, reactive, onMounted, defineEmits, defineProps, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import backendApi from '@/apis/axios-backend';
import PageLoader from '../pageLoaders/pageLoader.vue';
import PaymentInProgressDialog from '../common/PaymentInProgressDialog.vue';
import { getDistributer} from '@/mixins/common';
import { shouldSkipGodigitKycOvd } from '@/utils/godigitKycOvdSkip';
// Define emits
const emit = defineEmits(['close-modal', "resend-otp", "set-timer"]);
const props = defineProps({
  time: {
    type: Number,
    required: true
  }
})


// Setup function
const store = useStore();
const router = useRouter();
const refs = ref({});
const localTime = ref(props.time);
let hideMessage = ref(true);



// Reactive state
// Reactive state
const state = reactive({
        distributorID:'',
        loadingState: false,
        loadingMessage: "",
        hideError: false,
        OtpExpiryMessage: "",
        errorOtpMessage: "",
        OtpExpiryErrorMessage: null,
        otpExpiryTime: "",
        journeyId: "",
        otpNumbers: Array.from({ length: 6 }, (_, id) => ({ id, value: "" })),
        maskedData: JSON.parse(sessionStorage.getItem("maskedData")),
        rmData: "",
        selected_plan_data: sessionStorage.getItem('selected_plan_data') ? JSON.parse(sessionStorage.getItem('selected_plan_data')) : null,
        // Payment In Progress Modal
        showPaymentInProgressModal: false,
        paymentInProgressMessage: "A payment is currently in progress. Initiating a new payment may result in duplicate transactions. Do you want to continue?",
});


onMounted(() => {
        state.distributorID = getDistributer()["distributerID"];
        refs.value[0]?.focus();
        state.journeyId = JSON.parse(sessionStorage.getItem("journey_id"));
        state.OtpExpiryMessage = "";
        state.OtpExpiryErrorMessage = JSON.parse(sessionStorage.getItem("OtpExpiryErrorMessage"));
        emit("set-timer")
        if (sessionStorage.getItem("rm_data")) {
                state.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
        }
});

// Methods
const onInput = (event, index) => {
        let inputValue = event.target.value;

        // Keep digits only
        inputValue = inputValue.replace(/\D/g, '');

        // Update the current OTP input
        if (inputValue.length > 0) {
                // Fill current and next inputs if multiple digits pasted
                inputValue.split('').forEach((digit, i) => {
                        if (index + i < state.otpNumbers.length) {
                                state.otpNumbers[index + i].value = digit;
                        }
                });

                // Focus next input
                const nextIndex = index + inputValue.length;
                if (nextIndex < state.otpNumbers.length) {
                        refs.value[nextIndex]?.focus();
                }
        } else {
                // Clear the current input if no valid digit
                state.otpNumbers[index].value = '';
                // Move focus to previous input
                if (index > 0) refs.value[index - 1]?.focus();
        }
};




const onKeyDown = (event, index) => {
        if (event.key === 'Backspace') {
                if (!state.otpNumbers[index].value && index > 0) {
                        // If the current field is empty, move focus to the previous field
                        const prevInput = refs.value[index - 1];
                        prevInput?.focus();
                }
        } else if (event.key === 'ArrowLeft') {
                // Move focus to the previous input on left arrow key
                if (index > 0) {
                        const prevInput = refs.value[index - 1];
                        prevInput?.focus();
                }
        } else if (event.key === 'ArrowRight') {
                // Move focus to the next input on right arrow key
                if (index < state.otpNumbers.length - 1) {
                        const nextInput = refs.value[index + 1];
                        nextInput?.focus();
                }
        }
};

const onPaste = (event, index) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('text').replace(/\D/g, ''); // keep digits only
    pastedData.split('').forEach((digit, i) => {
        if (index + i < state.otpNumbers.length) {
            state.otpNumbers[index + i].value = digit;
        }
    });
    const nextIndex = index + pastedData.length;
    if (nextIndex < state.otpNumbers.length) {
        refs.value[nextIndex]?.focus();
    }
};




const resendOtp = (e) => {
        e.preventDefault();
        emit("set-timer");
        refs.value[0]?.focus();
        hideMessage.value = true;
        const expiryTimeOfOtp = sessionStorage.getItem("ExpiryTime");
        const now = new Date();

        let expiryDate = null;
        if (expiryTimeOfOtp) {
                expiryDate = new Date(expiryTimeOfOtp);
        }
        emit("resend-otp");
        sessionStorage.setItem("OtpExpiryMessage", JSON.stringify({
                type: "success",
                msg: "OTP sent to your mobile"
        }));

        state.OtpExpiryMessage = JSON.parse(sessionStorage.getItem("OtpExpiryMessage"));
        state.otpNumbers.forEach(otp => {
                otp.value = "";
        });
        refs.value[0]?.focus();

        setTimeout(() => {
                hideMessage.value = false;
                state.OtpExpiryMessage = "";
        }, 3000);
};


const validateOTP = () => {
        let companyCode = JSON.parse(sessionStorage.getItem('selected_plan_data'))
        const otpTransactionId = JSON.parse(sessionStorage.getItem('otpId'));
        const reqData = {
                distributor: {
                        distributorID: state.distributorID,
                        channelType: state.rmData.RoleId !== "1" ? "B2B" : "B2C",
                },
                insuranceCompanyCode: companyCode.insuranceAndProducts.insuranceCompanyCode,
                UITrackingRefNo: "279887d3-0370-4ad0-aab6-328135af94f2",
                OTPDetails: {
                        OTP: state.otpNumbers.map(otp => otp.value).join(''),
                        OTPTransactionId: otpTransactionId
                }
        };
        const headers = { "Authorization": `Bearer ${store.state.token}`};

        state.loadingState = true
        state.loadingMessage = "Validating your OTP..."

        backendApi("getOtpValidate", reqData, headers, "post")
                .then(response => {
                        if (response && response.data) {
                                if (response.data.data.OTPAccepted === "Yes") {
                                        state.loadingState = false;
                                        saveProposal();
                                }else if(response.data.data.OTPAccepted === "No"){
                                        hideMessage.value = true;
                                        state.loadingState = false;
                                        state.errorOtpMessage = response.data.data.reason
                                        setTimeout(() => {
                                                state.errorOtpMessage = "";
                                                hideMessage.value = false; 
                                        }, 3000);
                                }
                        }
                })
                .catch(error => {
                        console.error(error);
                        // state.loadingState = false
                });

        state.otpNumbers.forEach(otp => {
                otp.value = "";
        });
        refs.value[0]?.focus();
};

const formatCurrentDate = (now) => {
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const milliseconds = String(now.getMilliseconds()).padStart(3, '0');
        const microseconds = milliseconds + '000';
        const timezoneOffset = -now.getTimezoneOffset();
        const offsetHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
        const offsetMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
        const timezoneSign = timezoneOffset >= 0 ? '+' : '-';

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${microseconds}${timezoneSign}${offsetHours}:${offsetMinutes}`;
};

const saveProposal = () => {
        const expiryTime = JSON.parse(sessionStorage.getItem('expiryTime'));
        const reqData = {
                journey_id: state.journeyId,
                otpDetails: {
                        fields: {
                                otpReqCreatedTime: { input: formatCurrentDate(new Date()) },
                                otpReqUpdatedTime: { input: expiryTime },
                                otpReqOtpNo: { input: "" },
                                otpReqStatus: { input: "1" },
                                otpReqExpiryTimeInMin: { input: expiryTime }
                        }
                }
        };
        const headers = { "Authorization": `Bearer ${store.state.token}` };
        state.loadingState = true;
        state.loadingMessage = "Saving Proposal...."
        
        backendApi("saveProposal", reqData, headers, "post")
        .then(response => {
                if (response && response.data) {
                                state.loadingState = false;
                                proposalSubmission();
                        }
                })
                .catch(error => {
                        // state.loadingState = false;
                        console.error(error);
                });
};

const proposalSubmission = () => {
        const reqData = {
                journey_id: state.journeyId,
                redirect_url: new URL(location).origin + "/#/confirm-payment-diy"
        };
        const headers = { "Authorization": `Bearer ${store.state.token}` };
        state.loadingState = true;
        state.loadingMessage = "Submitting Proposal..."
        
        backendApi("saveProposal", reqData, headers)
        .then(response => {
                if(response && response.data.errors.length > 0){
                        emit('show-error-message', response.data)
                }
                if (response && response.data.data  && response.data?.errors.length ==0) {
                        state.loadingState = false;
                        paymentUrlPoll();
                }
        })
        .catch(error => {
                state.loadingState = false;
                console.error(error);
        });
};

const paymentUrlPoll = async (override = false) => {
        state.loadingState = true;
        state.loadingMessage = "Redirecting to payment gateway..."
        state.journeyId = JSON.parse(sessionStorage.getItem("journey_id"));
        try {
                const startTime = Date.now();
                const endTime = startTime + 3 * 60 * 1000;
                const stage = "Payment URL";
                // Add override parameter (pass "true" if override is needed, "false" otherwise)
                const reqData = [state.journeyId, stage, override ? "true" : "false"];
                const headers = {};
                const PAY_SETTINGS = store.state.configData['PAY_SETTINGS'];
                const insuranceCompanyCode = state.selected_plan_data.insuranceAndProducts.insuranceCompanyCode;

                while (Date.now() < endTime) {
                        const response = await backendApi("getPaymentUrlPoll", [], headers, "get", reqData);
                        // Stop polling if response has errors
                        if (response.data?.errors && response.data.errors.length > 0) {
                                const paymentInProgressError = response.data.errors.find(
                                        (error) => error.errorCode === "PAYMENT_IN_PROGRESS"
                                );
                                if (paymentInProgressError && !override) {
                                        state.loadingState = true;
                                        state.loadingMessage = "Redirecting to payment gateway...";
                                        return paymentUrlPoll(true);
                                }
                                cancleOtpVerify();
                                state.loadingState = false;
                                emit('show-error-message', response.data);
                                return;
                        }
                        if (response.data.errors.length === 0) {
                                if (response.data.data.proposal_response && response.data.data.proposal_response.errors && response.data.data.proposal_response.errors.length > 0) {
                                        const paymentInProgressError = response.data.data.proposal_response.errors.find(
                                                (error) => error.errorCode === "PAYMENT_IN_PROGRESS"
                                        );
                                        if (paymentInProgressError && !override) {
                                                state.loadingState = true;
                                                state.loadingMessage = "Redirecting to payment gateway...";
                                                return paymentUrlPoll(true);
                                        }
                                        emit('show-error-message', response.data.data.proposal_response);
                                        return;
                                } else if (!response.data.data.payment_url && ["Scrutiny", "INSPECTION REQUIRED"].includes(response.data.data.proposal_response?.policy?.policyStatus)) {
                                        const inspectionLink = response?.data?.data?.proposal_response?.inspectionDetails?.selfInspectionLink;
                                        const inspectionvalidTill = response?.data?.data?.proposal_response?.inspectionDetails?.inspectionValidTill;
                                        if (inspectionLink) {
                                                sessionStorage.setItem("inspectionLink", JSON.stringify(inspectionLink));
                                        }
                                        if (inspectionvalidTill) {
                                                sessionStorage.setItem("inspectionvalidTill", JSON.stringify(inspectionvalidTill));
                                        }

                                        sessionStorage.setItem("payment-url-response", JSON.stringify(response?.data?.data?.proposal_response.policy))
                                        sessionStorage.setItem("payment-poll-url", JSON.stringify(response?.data?.data?.proposal_response.ManufacturerTracking))
                                        router.push('/inspection');
                                        return;
                                } else if (PAY_SETTINGS && PAY_SETTINGS[insuranceCompanyCode] === 'POST') {
                                        if (response?.data?.data?.proposal_response?.status?.code === '200' && response.data.data.payment_url) {
                                                window.location.href = response.data.data.payment_url;
                                                return;
                                        }
                                } else if (response.data.data?.proposal_response?.status?.code === '200') {
                                        const isOvd = manageOvd('BEFORE_PAYMENT');
                                        if (isOvd) {
                                                if (response.data.data?.proposal_response?.ManufacturerTracking?.applicationNumber) {
                                                        sessionStorage.setItem('applicationNumber', JSON.stringify(response.data.data.proposal_response.ManufacturerTracking.applicationNumber));
                                                }
                                                sessionStorage.setItem('proposal_response', JSON.stringify(response.data.data?.proposal_response));
                                                if (response.data.data.payment_url) {
                                                        sessionStorage.setItem('payment_url', JSON.stringify(response.data.data.payment_url));
                                                }
                                                checkKycMode();
                                                return;
                                        }
                                        if (response.data.data.payment_url) {
                                                window.location.href = response.data.data.payment_url;
                                                return;
                                        }
                                } else if (response.data.data.payment_url) {
                                        window.location.href = response.data.data.payment_url;
                                        return;
                                }
                        }
                        await new Promise(resolve => setTimeout(resolve, 1000));
                }
                cancleOtpVerify();
                state.loadingState = false;
        } catch (error) {
                console.error("An error occurred during payment URL polling:", error);
                cancleOtpVerify();
                state.loadingState = false;
        }
};

const checkKycMode = () => {
        if (shouldSkipGodigitKycOvd(state.selected_plan_data)) {
                sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
                return;
        }
        const kycMode = store.state.configData["KYCMODE"];
        let kyc_mode = kycMode[state.selected_plan_data['insuranceAndProducts']['productCode']];
        if (!kyc_mode) {
                kyc_mode = kycMode[state.selected_plan_data['insuranceAndProducts']['insuranceCompanyCode']];
        }
        if (kyc_mode == 'POST') {
                sessionStorage.setItem('nextRef', JSON.stringify('payment'));
                router.push('/ckyc-form?nextRef=payment');
                return;
        }
};

const manageOvd = (mode) => {
        if (shouldSkipGodigitKycOvd(state.selected_plan_data)) {
                sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
                return false;
        }
        const OVD_KYC = store.state.configData?.OVD_KYC;
        const insurerCode = state.selected_plan_data.insuranceAndProducts.insuranceCompanyCode;

        let kyc_response = sessionStorage.getItem("kyc_response");
        kyc_response = kyc_response ? JSON.parse(kyc_response) : null;
        const kycStatus = kyc_response?.kycInfo?.Status;

        const isNotApproved = kycStatus !== "approved";

        const modeMapping = {
                BEFORE_PAYMENT: 'POST_PROPOSAL',
                AFTER_PAYMENT: 'POST_PAYMENT'
        };

        const requiredMode = modeMapping[mode];
        const configValue = OVD_KYC?.[insurerCode];

        if (configValue === requiredMode && (!kyc_response || isNotApproved)) {
                return true;
        }

        return false;
};


const handlePaymentInProgressContinue = () => {
        // Close the dialog
        state.showPaymentInProgressModal = false;
        // Call paymentUrlPoll again with override=true
        state.loadingState = true;
        state.loadingMessage = "Redirecting to payment gateway...";
        paymentUrlPoll(true);
};

const handlePaymentInProgressCancel = () => {
        // Close the dialog
        state.showPaymentInProgressModal = false;
        // Stop the journey, stop the API, and set loading to false
        state.loadingState = false;
        state.loadingMessage = "";
};

const cancleOtpVerify = () => {
        emit('close-modal');
};

const disableVerify = computed(() => {
        return state.otpNumbers && state.otpNumbers.some(otp => String(otp.value).trim() === "");
});

// Watch for changes in `time` prop
watch(() => props.time, (newTime) => {
  localTime.value = newTime;
});
</script>


<style scoped lang="scss">
@import "../../assets/scss/components/select-card.scss";


</style>